import { Injectable } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { IDialog } from "../models/dialog.model";
import { ConfirmDialogComponent } from "../app/sotheby-common/confirm-dialog/confirm-dialog.component";
import { SnackBarComponent } from "../app/sotheby-common/snack-bar/snack-bar.component";
import { DialogAction } from "src/models/action-dialog.model";
import { AlertDialogComponent } from "src/app/sotheby-common/alert-dialog/alert-dialog.component";
import { IndicatorDialogComponent } from "src/app/sotheby-common/indicator-dialog/indicator-dialog.component";
import { BehaviorSubject } from "rxjs";
import { NGXLogger } from "ngx-logger";

@Injectable({
  providedIn: "root",
})
export class CommonService {
  data: IDialog = new (class implements IDialog {
    action: number;
    content: string;
    title: string;
  })();

  constructor(
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private logger: NGXLogger
  ) {}

  confirmCreate() {
    this.data = <IDialog>{
      title: "잠시만요!",
      content: "정말 등록하시겠습니까?",
      action: DialogAction.create,
    };
    return this.confirm(this.data);
  }

  alertMessage(content: string) {
    this.data = <IDialog>{
      title: "잠시만요!",
      content: content,
      action: DialogAction.read,
    };
    return this.alert(this.data);
  }

  alertIndicator(message: string) {
    this.data = <IDialog>{
      title: "잠시만요!",
      content: message,
      action: DialogAction.read,
    };

    return this.indicatorDialog(this.data);
  }

  confirmDelete() {
    this.data = <IDialog>{
      title: "잠시만요!",
      content:
        "삭제한 데이터는 복구할 수 없습니다.<br />정말로 삭제하시겠습니까?",
      action: DialogAction.delete,
    };
    return this.confirm(this.data);
  }

  private indicatorDialog(data: IDialog) {
    const dialogRef = this.dialog.open(IndicatorDialogComponent, {
      data: { ...data },
    });

    return dialogRef;
  }

  private alert(data: IDialog): Promise<boolean> {
    const dialogRef = this.dialog.open(AlertDialogComponent, {
      data: { ...data },
    });
    return new Promise((resolve) => {
      dialogRef.afterClosed().subscribe((result) => {
        this.logger.log("alert dialog closed", result);
        resolve(!!result);
      });
    });
  }

  // data에 담긴 값을 이용해 실제로 dialog를 띄우고, Promise를 return하는 실행 로직이 담긴 메소드.
  private confirm(data: IDialog): Promise<boolean> {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: { title: data.title, content: data.content, action: data.action },
    });

    return new Promise((resolve) => {
      dialogRef.afterClosed().subscribe((result) => {
        this.logger.log("confirm dialog closed", result);
        resolve(!!result);
      });
    });
  }

  toastCreated() {
    this.toast("저장했습니다.");
  }

  toastFailed() {
    this.toast("문제가 발생했습니다.");
  }

  authFail() {
    this.toast("인증에 실패하였습니다.", 3000);
  }

  toastContactToAdmin() {
    this.toast("관리자에게 문의하세요.", 3000);
  }
  toastMessage(content: string) {
    this.toast(content, 3000);
  }
  private toast(content: string, duration: number = 1000) {
    this.snackBar.openFromComponent(SnackBarComponent, {
      duration: duration,
      data: content,
    });
  }

  private selectedVendor = new BehaviorSubject<any>("");
  selectedVendor$ = this.selectedVendor.asObservable();
  changeVendor(vendorInfo: any) {
    this.selectedVendor.next(vendorInfo);
  }
}
